<template>
  <div class="container activity-page">
        <ul>
          <li class="activity_item" v-for="item in myActity">
            <a :href="item.redirectUrl">
             <p class="date">{{item.createAtStr}}</p>
             <div class="item_wrap">
             <div class="card_des">
               <img :src="item.imgUrl" alt="">
               <div class="btn_wrap">
                <!-- <router-link class="toWelfare" :to="{ path: '/my/activity' }"> -->
                  <p>{{item.title}}</p>
                  <!-- <span>中粮礼盒<i class="red"></i></span> -->
                  <i class="arrow_right"></i>
              <!-- </router-link> -->
              
             </div>
               
             </div>
             
             </div>
             </a>
          </li>
        </ul>
       
        <home :ishome=0></home>
  </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'

export default {
  data () {
    return {
     	loading:true
    }
  },
  components:{
    home
  },
  computed:{   	 	 
  	 ...mapGetters({
      myActity:'getmyActivity',
      isShowMergeNav:'getisShowMergeNav'
    }),

  },
  watch:{
    myActity(cval){
      if(cval){
        this.loading=false;
      }
    }
  },
  created(){
    this.$store.dispatch('loadMyActity')
  },
  methods:{

  },
  mounted(){}
}
</script>